// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1LM2o","container":"styles_container__1MnlA","title":"styles_title__R4ZJh","wrapper":"styles_wrapper__3ABwI","answer":"styles_answer__352N4"};